<template>
  <!-- 文件预览 -->
  <div v-loading="fileLoading" :style="{ height: pageHeight + 'px' }" style="overflow: hidden; width: 100%">
    <office-view v-if="currentData.type == 1" :url="currentData.src" :name="currentData.name"></office-view>
  </div>
</template>
<script>
import officeView from './office-view/office-view.vue'
export default {
  components: { officeView },
  data() {
    return {
      src: 'xxx',
      url: this.$route.query.url,
      fileLoading: false,
      pageHeight: document.documentElement.clientHeight,
      currentData: {
        type: 1, //0普通文件 1office  2图片  3视频
        src: this.$route.query.src,
        name: '1234',
        content: '',
        language: '',
        isReset: true,
        vid: '',
      },
    }
  },
  mounted() {
    window.addEventListener('resize', this.onResize)
    this.initPage(this.currentData, this.videoId)
  },
  created() {},
  methods: {
    onResize() {
      this.pageHeight = this.type == 0 ? document.documentElement.clientHeight : this.height
    },
    initPage(u, v) {
      if (this.url) {
        this.currentData.src = this.url
      }
      if (this.type == 1) {
        this.url = u
        this.vid = v
      }
    },
  },
}
</script>

<style lang="scss">
</style>

